import { html } from "htm/preact";
import { useEffect, useState, useRef } from "preact/hooks";

// Fix the IntersectionObserver when the section is not first or last

export default function PageSections({
  title,
  sections
}) {
  const [activeId, setActiveId] = useState(null);
  const navRef = useRef(null);

  const observePageSections = () => {
    const sectionLinks = []

    const htmlLinks = navRef.current.querySelectorAll("a");
    const header = document.getElementById("header");

    htmlLinks.forEach((link) => {
      const targetId = link.getAttribute("href");
      if (targetId && targetId.startsWith("#")) {
        const targetSection = document.querySelector(targetId);
        if (targetSection) {
          sectionLinks.push({
            section: targetSection,
            link: link,
          });
        }
      }
    })

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        let mostVisibleSection = null;
        let maxVisibility = 0;

        // Find the section with highest visibility ratio
        entries.forEach((entry) => {
          if (entry.intersectionRatio > maxVisibility) {
            maxVisibility = entry.intersectionRatio;
            mostVisibleSection = entry.target;
          }
        });

        // Update active link based on most visible section
        if (mostVisibleSection) {
          sectionLinks.forEach((item) => {
            item.link.removeAttribute("data-active");
          });

          sectionLinks.forEach(item => {
            if (item.section === mostVisibleSection) {
              item.link.setAttribute("data-active", "");
            }
          });
        }
      },
      { 
        // Threshold creates 11 visibility checkpoints from 0% to 100% (every 10%)
        // This fires the observer callback ~10 times per section for reliable tracking
        threshold: Array.from({length: 11}, (_, i) => i / 10),
        // rootMargin accounts for the fixed header height at the top,
        // so visibility is calculated from below the header to the bottom of the viewport
        rootMargin: `-${header.offsetHeight}px 0px 0px 0px` 
      }
    );

    sectionLinks.forEach((item) => sectionObserver.observe(item.section));
    
    return sectionObserver;
  };

  useEffect(() => {
    const observer = observePageSections();

    return () => {
      observer && observer.disconnect();
    };
  }, []);

  return html`<nav ref=${navRef} id="nav-sections" class="w-full flex gap-4 overflow-x-auto flex-nowrap scrollbar-none touch-pan-x lg:justify-center">
    <div class="px-3 py-1 whitespace-nowrap flex-shrink-0 font-semibold">
      <span>${title}</span>
    </div>
      ${Object.values(sections).map(section => {
    return html`
      <a role="button" href="#${section.id}"
        class="transition-colors px-3 py-1 rounded-md data-active:bg-olive-100 hover:bg-olive-100 whitespace-nowrap flex-shrink-0"
        onclick=${(e) => {
        setActiveId(section.id);
      }}>
        <span>${section.title}</span>
      </a>`
  })}
  </nav>`
}